<template>
  <div class="row dashboard-warning-widgets">
    <!-- {{ Device }} -->
    <div class="col-md-6 col-xl-3">
      <vuestic-widget class="warning-widget">
        <div class="warning-widget-inner">
          <div class="stats">
            <div class="stats-number">
              <i class="icon glyphicon glyphicon-building-o text-primary stats-icon"></i>
              {{ activePower(Device.parameters) }}
            </div>
            <div class="stats-title">Load Active Power</div>
          </div>
        </div>
      </vuestic-widget>
    </div>
    <div class="col-md-6 col-xl-3">
      <vuestic-widget class="warning-widget">
        <div class="warning-widget-inner">
          <div class="stats">
            <div class="stats-number">
              <!-- <i class="icon fa fa-plug text-danger stats-icon"></i> -->
              {{ (Device.parameters.outputLoadPercent) }}%
            </div>
            <div class="stats-title">Load Percentage</div>
          </div>
        </div>
      </vuestic-widget>
    </div>
    <div class="col-md-6 col-xl-3">
      <vuestic-widget class="warning-widget">
        <div class="warning-widget-inner">
          <div class="warning-widget-inner">
            <div class="stats">
              <div class="stats-number">
                <div class="battery" style="clear: both;"><div class="level" v-bind:style="battery_meter" ref="battery_level"></div></div>
              </div>
              <div class="stats-title">
                {{ batteryMode(Device.modeinquiries.mode) }}
                <br>
                <small style="font-size: 1.4rem;">{{ Device.parameters.batteryCapacity }}%</small>
                <br>
                <small style="font-size: 1.4rem;">{{ Device.parameters.batteryVoltage }}volt</small>
              </div>
            </div>
          </div>
        </div>
      </vuestic-widget>
    </div>
    <div class="col-md-6 col-xl-3">
      <vuestic-widget class="warning-widget">
        <div class="warning-widget-inner">
          <div class="stats">
            <div class="stats-number">
              {{ powerToday(Device.generated.consumed) }}
            </div>
            <div class="stats-title">Energy Consumed Today</div>
          </div>
        </div>
      </vuestic-widget>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
// import ProgressBar from "../../vuestic-components/vuestic-progress-bar/VuesticProgressBar";
import moment from "moment";
export default {
  name: "power-stat-widget",
  props: ["Device"],
  data: function() {
    return {
      battery_meter: {
        background: "green",
        width: "50%"
      }
    };
  },
  components: {
    // ProgressBar
  },
  methods: {
    batUpdate(charge) {
      // var batt_metter =
      this.$refs.battery_level.style.width = charge + "%";
      var bg;
      if (charge < 20) {
        // Red - Danger!
        // col = ['#750900', '#c6462b', '#b74424', '#df0a00', '#590700']
        bg =
          "linear-gradient(45deg, rgba(255,0,0,1) 0%, rgba(128,0,0,1) 2%, rgba(252,0,0,1) 98%, rgba(255,0,0,1) 100%)";
      } else if (charge < 40) {
        // Yellow - Might wanna charge soon...
        // col = ['#754f00', '#f2bb00', '#dbb300', '#df8f00', '#593c00']
        bg =
          "linear-gradient(45deg, #754f00 0%, #f2bb00 2%, #dbb300 98%, #df8f00 100%)";
      } else {
        // Green - All good!
        // col = ['#316d08', '#60b939', '#51aa31', '#64ce11', '#255405']
        bg =
          "linear-gradient(45deg, #316d08 0%, #60b939 2%, #51aa31 98%, #64ce11 100%)";
      }
      this.battery_meter.background = bg;
      this.$refs.battery_level.style.background = bg;
    },
    roundUp(num) {
      return Math.round(num * 100) / 100;
    },
    Parse_Json(data) {
      return JSON.parse(data);
    },
    countErrors(Warning) {
      var excluded = [
        "id",
        "DeviceID",
        "DeviceTimeStamp",
        "createdAt",
        "updatedAt"
      ];
      var totalErr = 0;
      for (var property in Warning) {
        if (
          Warning.hasOwnProperty(property) &&
          excluded.indexOf(property) < 0
        ) {
          if (Warning[property] > 0) {
            totalErr++;
          }
        }
      }
      var msg_ = " Error";
      if (totalErr > 1) {
        msg_ = " Errors";
      }
      return totalErr + msg_;
    },
    batteryMode(mode) {
      var resp = "--";
      switch (mode) {
        case "P":
          resp = "Power On";
          break;
        case "S":
          resp = "On Standby";
          break;
        case "L":
          resp = "On Grid";
          break;
        case "B":
          resp = "On Battery";
          break;
        case "F":
          resp = "Fault";
          break;
        case "H":
          resp = "Power saving mode";
          break;
        case "C":
          resp = "Charging";
          break;
        default:
      }
      return resp;
    },
    timeAgo(date) {
      var difference = moment(date).fromNow();
      return difference;
    },
    panelPower(parameters) {
      var power = this.roundUp(
        parameters.pVInputCurrent * 1 * (parameters.pVInputVoltage * 1) / 1000
      );
      return power + " kW";
    },
    activePower(parameters) {
      var power = this.roundUp(parameters.aCOutputActivePower * 1 / 1000);
      return power + " kW";
    },
    powerToday(powr) {
      return this.roundUp(powr) + " kWh";
    }
  },
  mounted() {
    // this.batUpdate(this.Device.parameters.batteryCapacity * 1)
    this.batUpdate(this.Device.parameters.batteryCapacity * 1);
  },
  updated() {
    // console.log('++++++++++++++++++++++++++++++++++++++++++')
    // console.log(this.Device.parameters.batteryCapacity)
    // this.batUpdate(this.Device.parameters.batteryCapacity * 1)
  }
};
</script>

<style lang="scss" scoped>
// @import "../../../sass/_variables.scss";

.stats-number,
.stats-title {
  line-height: 1;
  text-align: center;
}

.warning-widget-inner {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 100%;

  &.has-chart {
    justify-content: space-between;
  }

  .stats {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    border: 4px solid #eee;
    height: 159px;
    width: 159px;
    border-radius: 50%;
  }
}

.stats-number {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-size: 2.625rem;
  margin-bottom: 0.5rem;

  .stats-icon {
    font-size: 1.5625rem;
    position: absolute;
    top: 0.625rem;
    left: -1.25rem;

    &.icon-wide {
      left: -1.875rem;
    }
  }
}

$batteryWidth: 100px;
$batteryHeight: 50px;
$batteryBorderSize: 1px;
$batteryStrokeColor: rgba(0, 0, 0, 0.45);
$batteryBorderRadius: 2px;
$batteryNubSize: $batteryHeight * 0.5;

.battery {
  position: relative;
  width: $batteryWidth;
  height: $batteryHeight;
  border: $batteryBorderSize solid $batteryStrokeColor;
  border-radius: $batteryBorderRadius;
  position: relative;
  padding: $batteryBorderSize;
  // background-image: linear-gradient(to right, transparent 5%, #316d08 5%, #316d08 7%, #60b939 8%, #60b939 10%, #51aa31 11%, #51aa31 60%, #64ce11 61%, #64ce11 63%, #255405 63%, black 68%, black 95%, transparent 95%), linear-gradient(to bottom, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 0.4) 4%, rgba(255, 255, 255, 0.2) 7%, rgba(255, 255, 255, 0.2) 14%, rgba(255, 255, 255, 0.8) 14%, rgba(255, 255, 255, 0.2) 40%, rgba(255, 255, 255, 0) 41%, rgba(255, 255, 255, 0) 80%, rgba(255, 255, 255, 0.2) 80%, rgba(255, 255, 255, 0.4) 86%, rgba(255, 255, 255, 0.6) 90%, rgba(255, 255, 255, 0.1) 92%, rgba(255, 255, 255, 0.1) 95%, rgba(255, 255, 255, 0.5) 98%);
  // -webkit-transform: scale(0.5);//for retina display
  &:before {
    content: "";
    display: block;
    position: absolute;
    top: 50%;
    right: -1 * (($batteryNubSize * 0.35) + $batteryBorderSize + 2);
    margin-top: -1 * ($batteryNubSize/2);
    width: $batteryNubSize;
    height: $batteryNubSize;
    background: $batteryStrokeColor;
    clip: rect(0, $batteryNubSize, $batteryNubSize, ($batteryNubSize * 0.65));
    border-radius: 50%;
  }
  &.plugged:after {
    content: "";
    display: block;
    position: absolute;
    top: 50%;
    right: -1 * ($batteryBorderSize + ($batteryWidth * 0.5));
    margin-top: -1 * ($batteryNubSize/2);
    width: $batteryNubSize;
    height: $batteryNubSize;
    background: #f00;
    border-radius: 50%;
  }
  .level {
    width: 20%;
    height: 100%;
    background: $batteryStrokeColor;
    border-radius: $batteryBorderRadius/2;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/performance/powerStat.vue